import { mapActions, mapState } from 'vuex';

export default {
  props: {
    showSwitchButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      altModeOn: false,
    };
  },
  computed: {
    ...mapState('overlay', ['visible']),
    isAltViewModifier() {
      return {
        'modal-switch--isAltView': this.altModeOn,
      };
    },
  },
  methods: {
    ...mapActions('overlay', ['show', 'hide']),
    close() {
      this.hide();
      this.$emit('modalClose');
    },
    toggle() {
      this.altModeOn = !this.altModeOn;
      this.$emit('modalToggle');
    },
  },
  watch: {
    visible() {
      if (!this.visible) {
        this.close();
      }
    },
  },
  created() {
    this.show();
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/modal/switch/switch.js